import { render, staticRenderFns } from "./UserFeed.vue?vue&type=template&id=6a3b1378"
import script from "./UserFeed.vue?vue&type=script&lang=ts"
export * from "./UserFeed.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports